const studentDashboardReducer = (state = null, action) => {
    switch (action.type) {
        case "UPDATE_STUDENT_DASHBOARD":
            state = {
                ...state,
                dashboard: {
                    ...state.dashboard,
                    ...action.payload,
                },
            };
            state = action.payload;
            return state;
        case "CLEAR_STUDENT_DASHBOARD":
            return null;
        default:
            return state;
    }
}

export default studentDashboardReducer;